import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Info = () => import('./views/Info')

const ROUTE_NAME = 'profile:auto-application:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const INFO = p('info')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(['RESERVATION:AUTO_APPLICATION:VIEW'], options),
    }),
    route('info/', Info, INFO, {
      props: true,
      meta: accessPermission(['RESERVATION:AUTO_APPLICATION:ADD'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
